(function($) {
  function preload(arrayOfImages) {
    $(arrayOfImages).each(function(){
        $('<img/>')[0].src = this;
        // Alternatively you could use:
        // (new Image()).src = this;
    });
  }

  $(window).load(function(){
    $('.hero.homepage-hero .slides').each(function(){
      var url = $(this).attr('data-image');
      preload(url);
    });
  });

  var index = 0;
  let shapes =
  [
    'M815.545 230.644C751.545 -34.1558 612.878 -17.6892 551.545 23.6442C540.878 29.3108 512.145 56.4442 482.545 119.644C445.545 198.644 415.545 275.644 240.545 186.644C65.5451 97.6442 18.6802 222 12.5449 256.644C10.0525 270.719 6.16861 355.915 3.38273 440C0.739181 519.789 -0.915731 598.577 0.544948 614.644C2.16974 632.517 18.4609 682.949 55.932 724C87.6472 758.745 134.535 786.77 200.545 782.644C315.745 775.444 364 798.664 386.545 811.644C518.545 887.644 638.878 909.977 682.545 911.644C906.545 915.644 958.545 727.644 940.545 620.644C932.952 575.507 907.684 497.436 880.708 419C856.526 348.688 830.971 278.082 815.545 230.644Z',
    'M552.325 85.1251C489.283 122.386 416.308 139.242 343.231 134.542C251.217 128.613 175.87 156.591 120.114 194.665C60.1083 235.64 22.792 288.308 11.8067 322.992C-12.7564 400.732 2.71687 487.64 42.3958 558.867C82.0493 630.094 143.994 686.867 212.066 731.661C265.303 766.649 324.311 795.533 387.634 802.352C449.502 809.018 511.497 794.333 571.705 778.55C649.148 758.273 727.331 735.466 794.816 692.383C849.841 657.267 900.27 598.017 888.907 533.711C879.205 478.905 827.372 438.554 818.614 383.595C806.358 306.622 881.554 242.366 891.614 165.061C903.334 74.8842 838.632 0.541165 776.815 0.00485485C712.394 -0.531456 622.184 43.8037 552.325 85.0996V85.1251Z',
    'M67.2731 355.554C116.421 441.569 58.438 594.055 68.4014 664.565C77.5385 729.099 144.35 799.226 209.867 833.876C275.385 868.526 367.316 856.631 409.605 795.763C427.989 769.264 435.836 736.681 453.834 709.899C511.419 624.231 640.123 632.284 728.291 578.66C829.905 516.824 861.452 381.454 849.573 263.104C842.017 187.844 818.92 110.669 765.4 57.1961C711.904 3.73644 622.57 -18.547 558.193 21.1683C500.178 56.9515 458.617 138.461 391.488 126.706C344.554 118.486 319.968 67.4841 282.754 37.7206C224.426 -8.90617 132.731 3.0022 77.5978 53.3696C22.4645 103.737 -13.5068 158.264 6.28637 230.264C15.5391 263.861 49.9831 325.35 67.2696 355.613L67.2731 355.554Z',
    'M343.131 157.856C293.214 243.427 132.165 269.456 76.0841 313.339C24.7645 353.519 -2.56183 446.443 0.189319 520.508C2.94047 594.572 59.2068 668.24 133.065 674.429C165.206 677.101 197.346 667.605 229.54 669.8C332.523 676.836 389.901 792.324 480.424 841.868C584.783 898.95 717.79 858.585 814.345 789.123C875.744 744.949 931.031 686.359 950.58 613.273C970.129 540.214 944.76 451.707 878.177 415.812C818.181 383.462 726.811 388.223 703.426 324.21C687.078 279.454 718.954 232.661 726.123 185.551C737.339 111.725 681.179 38.2687 609.993 15.7056C538.807 -6.85765 473.599 -10.746 421.142 42.3952C396.673 67.2068 360.643 127.781 343.078 157.883L343.131 157.856Z',
  ];
  var translates = [
    'translate(-182px, 68px) scale(0.95)',
    'translate(-94px, 155px) scale(0.765)',
    'translate(-218px, -35px) scale(0.965)',
    'translate(-87px, -21px)',
  ];

  function fade_element(ele, fade_type, delay){
    var image = ele.attr('data-image'),
    color = ele.attr('data-color');

    if(fade_type == 'fadeIn'){
      $('.homepage-hero svg path').attr('fill', '#'+ color);
    }

    setTimeout(function(){
      if(fade_type == 'fadeIn'){
        $('.homepage-hero svg image').attr('href', image);
        $('.homepage-hero svg image').fadeIn();

        ele.find('span').each(function(){
            $(this).css({
              'opacity': 1,
              'visibility': 'visible',
              'transform': 'translateY(0px)'
            });

            $(this).parent('h1').addClass('active');
          });

        $('.homepage-hero svg image').css({
          transform: translates[index]
        });

      } else {
        $('.homepage-hero svg image').fadeOut(function(){
          $('.homepage-hero svg image').attr('href', '');
        });

        ele.find('span').each(function(){
          $(this).css({
            'opacity': 0,
            'visibility': 'hidden',
            'transform': 'translateY(100px)'
          });

          $(this).parent('h1').removeClass('active');
        });
      }
    }, delay);
  }


  if($(".homepage-hero").length){

    $(".homepage-hero .slides").on('init', function(event, slick){
        let $initSlideElement = $(slick.$slides.get(0));
        fade_element($initSlideElement, 'fadeIn', 1500);

    });

    $(".homepage-hero .slides").slick({
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
      speed: 600,
      rows: false,
      swipe: false,
      pauseOnHover: false,
    });

    $(".homepage-hero .slides").on("beforeChange", function(event, slick, currentSlide, nextSlide) {
      let $slideElement = $(slick.$slides.get(currentSlide));

      fade_element($slideElement, 'fadeOut', 100);

      let $nextSlideElement = $(slick.$slides.get(nextSlide));

      fade_element($nextSlideElement, 'fadeIn', 1000);
    });
  }

})( jQuery );
